var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        { attrs: { padding: 0, bordered: false, "dis-hover": true } },
        [
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.mainTable.sarchCardShow
                ? _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("search-card", {
                            attrs: {
                              form: _vm.mainTable.searchForm,
                              "table-load-event": _vm.getMainTableRecords,
                              "table-search": _vm.mainTable.tableSearch,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c(
                    "div",
                    { staticClass: "left-bar" },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("预售仓明细"),
                      ]),
                      _c(
                        "Checkbox",
                        {
                          on: { "on-change": _vm.onShowHasStockOnly },
                          model: {
                            value: _vm.amountFilter,
                            callback: function ($$v) {
                              _vm.amountFilter = $$v
                            },
                            expression: "amountFilter",
                          },
                        },
                        [_vm._v("只看有仓存")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "right-bar" },
                    [
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "primary",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: {
                            click: function ($event) {
                              _vm.mainTable.sarchCardShow =
                                !_vm.mainTable.sarchCardShow
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "success",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: { click: _vm.onEntry },
                        },
                        [_vm._v("预售入库单")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "warning",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: { click: _vm.onTransformList },
                        },
                        [_vm._v("调拨单")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "error",
                            size: "small",
                            shape: "circle",
                          },
                          on: { click: _vm.onAgentEntry },
                        },
                        [_vm._v("内部购销入库单")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "error",
                            size: "small",
                            shape: "circle",
                            icon: "ios-send",
                            ghost: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onClickImport()
                            },
                          },
                        },
                        [_vm._v("导入")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "info",
                            size: "small",
                            shape: "circle",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onExport()
                            },
                          },
                        },
                        [_vm._v("导出")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.mainTable.columns,
                      data: _vm.storeList,
                      loading: _vm.mainTable.tableLoading,
                      extHeight: 60,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getMainTableRecords,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            width: 60,
            title: "预售库调拨",
            "class-name": "vertical-center-modal",
          },
          model: {
            value: _vm.transformModal.show,
            callback: function ($$v) {
              _vm.$set(_vm.transformModal, "show", $$v)
            },
            expression: "transformModal.show",
          },
        },
        [
          _c(
            "Form",
            { staticClass: "small-form", attrs: { "label-position": "top" } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "仓库" } },
                        [
                          _c("Input", {
                            attrs: {
                              value: _vm.transformModal.warehouseName,
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "产品编号" } },
                        [
                          _c("Input", {
                            attrs: {
                              value: _vm.transformModal.productCode,
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "产品名称" } },
                        [
                          _c("Input", {
                            attrs: {
                              value: _vm.transformModal.productName,
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "批次号" } },
                        [
                          _c("Input", {
                            attrs: {
                              value: _vm.transformModal.transformBatchCode,
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "仓存量" } },
                        [
                          _c("Input", {
                            attrs: {
                              value: _vm.transformModal.Amount,
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "销售期限" } },
                        [
                          _c("Input", {
                            attrs: {
                              value: _vm.transformModal.transformSalePeriod,
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "过鲜日期" } },
                        [
                          _c("Input", {
                            attrs: {
                              value: _vm.formatDateTimeString(
                                _vm.transformModal.expiredDate
                              ),
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "入库价" } },
                        [
                          _c("Input", {
                            attrs: {
                              value: _vm.transformModal.transformPrice,
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "5" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "目标仓库" } },
                        [
                          _c(
                            "RadioGroup",
                            {
                              model: {
                                value: _vm.transformModal.transTarget,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.transformModal,
                                    "transTarget",
                                    $$v
                                  )
                                },
                                expression: "transformModal.transTarget",
                              },
                            },
                            [
                              _c("Radio", { attrs: { label: "现售仓" } }, [
                                _vm._v("现售仓"),
                              ]),
                              _c("Radio", { attrs: { label: "自用仓" } }, [
                                _vm._v("自用仓"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.transformModal.transTarget === "现售仓"
                    ? _c(
                        "Col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "销售类型" } },
                            [
                              _c(
                                "RadioGroup",
                                {
                                  model: {
                                    value: _vm.transformModal.isPublic,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.transformModal,
                                        "isPublic",
                                        $$v
                                      )
                                    },
                                    expression: "transformModal.isPublic",
                                  },
                                },
                                [
                                  _c("Radio", { attrs: { label: 1 } }, [
                                    _vm._v("公开"),
                                  ]),
                                  _c("Radio", { attrs: { label: 0 } }, [
                                    _vm._v("对内"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "调拨价" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, readonly: true },
                            model: {
                              value: _vm.transformModal.transformNewPrice,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.transformModal,
                                  "transformNewPrice",
                                  $$v
                                )
                              },
                              expression: "transformModal.transformNewPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "调拨数量" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { max: _vm.transformModal.Amount, min: 0 },
                            model: {
                              value: _vm.transformModal.transformAmount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.transformModal,
                                  "transformAmount",
                                  $$v
                                )
                              },
                              expression: "transformModal.transformAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "备注" } },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.transformModal.transformRemark,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.transformModal,
                                  "transformRemark",
                                  $$v
                                )
                              },
                              expression: "transformModal.transformRemark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary", loading: _vm.btnLoading },
                  on: { click: _vm.onTransform },
                },
                [_vm._v("确认")]
              ),
              _c(
                "Button",
                {
                  attrs: { type: "error" },
                  on: {
                    click: function ($event) {
                      _vm.transformModal.show = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            title: "调拨单",
            width: 80,
            "class-name": "vertical-center-modal",
          },
          model: {
            value: _vm.listModal.show,
            callback: function ($$v) {
              _vm.$set(_vm.listModal, "show", $$v)
            },
            expression: "listModal.show",
          },
        },
        [
          _c("stand-pagination-table", {
            attrs: {
              columns: _vm.listModal.table.columns,
              data: _vm.listModal.table.rows,
              loading: _vm.listModal.table.loading,
              "table-search": _vm.listModal.table.tableSearch,
              "table-load-event": _vm.getTransformListRecord,
            },
          }),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            title: "请选择要导入的文件",
            "mask-closable": false,
            loading: true,
            width: "300",
          },
          on: { "on-ok": _vm.onImportEntry },
          model: {
            value: _vm.importModel.show,
            callback: function ($$v) {
              _vm.$set(_vm.importModel, "show", $$v)
            },
            expression: "importModel.show",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "Upload",
                {
                  attrs: {
                    "show-upload-list": false,
                    action: _vm.UPLOAD_FILE_API,
                    format: ["xlsx"],
                    "on-success": _vm.handleSuccess,
                    "on-format-error": _vm.handleFormatError,
                  },
                },
                [
                  _c(
                    "Button",
                    { attrs: { icon: "ios-cloud-upload-outline" } },
                    [_vm._v("选择文件")]
                  ),
                ],
                1
              ),
              _c(
                "Button",
                {
                  attrs: { icon: "ios-cloud-download-outline" },
                  on: {
                    click: function ($event) {
                      return _vm.downloadImportTemplate()
                    },
                  },
                },
                [_vm._v("下载模板")]
              ),
            ],
            1
          ),
          _c("div", [_vm._v(_vm._s(_vm.importModel.fileName))]),
        ]
      ),
      _c("PreWarehouseEntryList", { ref: "preWarehouseEntryListModal" }),
      _c("PreSaleAgentWarehouseEntryList", {
        ref: "preSaleAgentWarehouseEntryList",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }